import React, { useState, useEffect } from "react";
import useGetListaURL from "../../hooks/useGetListaURL.js";
import ComboSelector, { TipoClave } from "../UI/campos/ComboSelector.js";
import { DescripcionFuente } from "../funciones/FuncionesInformacion.js";
import * as UI from "../constantes/UI.js";
import MensajeError from "../UI/MensajeError.js";
import { encontrarIdNumber } from "../funciones/FuncionesArray.js";

const SelectFuenteInformacion = (props) => {
  const fuenteActual = props.idActual;
  const incluirNulo = props.incluirNulo || false;
  const estilo = props.estilo;
  const [lista, setLista] = useState([]);
  const [listaOriginal, setListaOriginal] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  const itemActual = fuenteActual ? {id: fuenteActual.id, descripcion: DescripcionFuente(fuenteActual)} : null;

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    const setListaFuentes = (fuentesInformacion) => {
      let lista = fuentesInformacion.map(item => ({
        id: item.id, descripcion: DescripcionFuente(item)
      }));
      if (incluirNulo) {
        lista = [{ id: null, descripcion: UI.ITEM_COMBO_VACIO }, ...lista];
      }
      setLista(lista);
      setListaOriginal(fuentesInformacion);
    }

    fetchData("fuentes_informacion", setListaFuentes);
  }, [fetchData, incluirNulo]);

  const onItemElegido = (itemElegido) => {
    if (itemElegido) {
      props.onFuenteElegida(encontrarIdNumber(listaOriginal, itemElegido.id));
    }
  };

  let valorActual = "";
  if (itemActual) {
    if (itemActual.id) {
      valorActual = itemActual;
    } else if (lista.length > 0) {
      for (let i=0; i < lista.length; i++) {
        if (Number(lista[i].id) === Number(itemActual.id)) {
          valorActual = lista[i].id;
          break;
        }
      }
    }
  }

  return (
    <React.Fragment>
      <ComboSelector
        estilo={estilo}
        lista={lista}
        valorActual={valorActual}
        campoClave={TipoClave.CODIGO}
        campoDescripcion="descripcion"
        isCargando={isCargando}
        onItemElegido={onItemElegido}
      />
      <MensajeError errores={erroresGetLista} />
    </React.Fragment>
  );
};

export default SelectFuenteInformacion;
